import { getDownloadURL, list, ref } from "firebase/storage";
import React, { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { _showStates } from "../../../App";
import { allowAppStorage } from "../../../project/appConfiguration";
import { manifestSizes } from "../../components/imaging/createManifestIcons";
import { AppContext } from "./AppProvider";
import { PapsContext } from './PapsContext';
import { ClientSettingsContext, EventSettingsContext, HomeSettingsContext } from "./SettingsDataContext";
import { StorageContext } from "./StorageContext";
import { manifestHandlers, manifestInitialState, manifestReducer } from "../reducers/ManifestReducer";

/** 
@state manifest_state(`manifestIcons`, `startIcon`)
@functions manifest_fns (`getManifestUrl`)
@description Returns the `manifest icons` from storage base on the `storageManifestPath`
 */
export const ManifestContext = createContext();

/** Returns the `manifest icons` from storage base on the `storageManifestPath` */
const ManifestProvider = (props) => {

  const init_state = {}
  const [manifest_state, manifestDispatch] = useReducer(manifestReducer, manifestInitialState(init_state));
  const { manifestIcons } = manifest_state ?? {}

  const manifest_handlers = useMemo(
    () => manifestHandlers(manifestDispatch),
    [manifestDispatch]
  );

  const manifest_fns = useMemo(() => ({
    getManifestUrl: (size) =>
      manifestIcons?.[`manifest_${size}`]?.fileUrl ?? null,
  }), [manifestIcons]);

  if (_showStates.any && _showStates.manifest) {
    console.log('--- manifest ---')
    console.log(Object.keys(manifest_state).sort())
    console.log(Object.keys(manifest_fns).sort())
  }

  return (
    <ManifestContext.Provider value={{ manifest_state, manifest_handlers, manifest_fns }}>
      {props.children}
    </ManifestContext.Provider>
  );

}

export default ManifestProvider

const manifestPromise = async (mainStorage, res) => {

  const { items } = res ?? {}

  const promises = []

  items.forEach(function (itemRef) {
    const { _location } = itemRef
    const { path_ } = _location
    const iconRef = ref(mainStorage, path_)
    promises.push(getDownloadURL(iconRef))
  });

  return Promise.all(promises)

}

const getTrueSettings = (hceSettings) => {
  const { clients: settings_client, events: settings_event } = hceSettings
  const { global: global_client } = settings_client ?? {}
  const { global: global_event } = settings_event ?? {}
  const { appSettings: appSettings_client } = global_client ?? {}
  const { parentDefaults } = global_event ?? {}
  const { useClientManifest } = appSettings_client ?? {}
  const { useClientManifestIcon } = parentDefaults ?? {}
  if (useClientManifest || useClientManifestIcon) {
    return { settings: settings_client, useClient: true }
  } else {
    return { settings: settings_event, useClient: false }
  }
}

export const getManifestPath = (pathViews, useClient) => {
  let mp = ''
  if (pathViews?.events) {
    mp += 'clients/' + pathViews.clients + '/events/' + pathViews.events + '/global/manifests'
  } else if (pathViews?.clients) {
    mp += 'clients/' + pathViews.clients + '/global/manifests'
  } else {
    return '/global/manifests'
  }
  return mp
} 